module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Modal")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("弹出层")])]), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('p', [_c('test')], 1), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("show")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("控制弹出层显示，请使用"), _c('code', [_vm._v("v-model")]), _vm._v("获取及设置")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出层类型，可选值"), _c('code', [_vm._v("center/top/bottom/left/right")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("center")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("use_close")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否显示关闭按钮")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("use_mask")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否显示遮罩层")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("mask_close")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("点击遮罩层是否关闭弹出层")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("render_type")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("组件渲染类型，可选值"), _c('code', [_vm._v("show/if")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("show")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("use_shadow")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否使用阴影")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("background_color")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出层背景色")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("#fff")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("overflow")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出层的overflow")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("visible")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("z_index")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("组件的堆叠层级")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String/Number")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("999")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("border_radius")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("弹出层圆角")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("0")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("prevent_scroll")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("是否禁止页面滚动")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("true")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5002b1ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/index-21.vue
// module id = 654
// module chunks = 0